var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-card",
        { staticStyle: { "margin-bottom": "10px" } },
        [
          _c(
            "el-form",
            {
              attrs: {
                model: _vm.queryForm,
                "label-position": "top",
                size: "small",
              },
            },
            [
              _c(
                "el-row",
                { attrs: { gutter: 10 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 5 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("mdfeTranslate.InsuranceCompanyName"),
                          },
                        },
                        [
                          _c(
                            "template",
                            { slot: "label" },
                            [
                              _c(
                                "el-select",
                                {
                                  staticClass: "postcodeType-class",
                                  attrs: {
                                    placeholder: _vm.$t(
                                      "orderDetails.pleaseChoose"
                                    ),
                                  },
                                  model: {
                                    value: _vm.queryForm.params.nameType,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.queryForm.params,
                                        "nameType",
                                        $$v
                                      )
                                    },
                                    expression: "queryForm.params.nameType",
                                  },
                                },
                                [
                                  _c("el-option", {
                                    key: "1",
                                    attrs: {
                                      label: _vm.$t(
                                        "mdfeTranslate.InsuranceCompanyName"
                                      ),
                                      value: 1,
                                    },
                                  }),
                                  _c("el-option", {
                                    key: "2",
                                    attrs: {
                                      label: _vm.$t(
                                        "mdfeTranslate.ConfigurationName"
                                      ),
                                      value: 2,
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c("el-input", {
                            attrs: {
                              placeholder: _vm.$t(
                                "collectionCenter.pleaseInput"
                              ),
                              clearable: "",
                            },
                            model: {
                              value: _vm.queryForm.params.name,
                              callback: function ($$v) {
                                _vm.$set(_vm.queryForm.params, "name", $$v)
                              },
                              expression: "queryForm.params.name",
                            },
                          }),
                        ],
                        2
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 5 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: { label: _vm.$t("GlobalSetObj.EnableStatus") },
                        },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "100%" },
                              attrs: {
                                placeholder: _vm.$t(
                                  "collectionCenter.pleaseChoose"
                                ),
                                clearable: "",
                              },
                              model: {
                                value: _vm.queryForm.params.state,
                                callback: function ($$v) {
                                  _vm.$set(_vm.queryForm.params, "state", $$v)
                                },
                                expression: "queryForm.params.state",
                              },
                            },
                            [
                              _c("el-option", {
                                attrs: {
                                  label: _vm.$t("collectionCenter.tudo"),
                                  value: null,
                                },
                              }),
                              _c("el-option", {
                                attrs: {
                                  label: _vm.$t("collectionCenter.enable"),
                                  value: 1,
                                },
                              }),
                              _c("el-option", {
                                attrs: {
                                  label: _vm.$t("GlobalSetObj.disable"),
                                  value: 0,
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 9 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("collectionCenter.createTime"),
                          },
                        },
                        [
                          _c(
                            "template",
                            { slot: "label" },
                            [
                              _c(
                                "el-select",
                                {
                                  staticClass: "postcodeType-class",
                                  attrs: {
                                    placeholder: _vm.$t(
                                      "orderDetails.pleaseChoose"
                                    ),
                                  },
                                  model: {
                                    value: _vm.queryForm.params.timeType,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.queryForm.params,
                                        "timeType",
                                        $$v
                                      )
                                    },
                                    expression: "queryForm.params.timeType",
                                  },
                                },
                                [
                                  _c("el-option", {
                                    key: "1",
                                    attrs: {
                                      label: _vm.$t(
                                        "GlobalSetObj.CreationTime"
                                      ),
                                      value: 1,
                                    },
                                  }),
                                  _c("el-option", {
                                    key: "2",
                                    attrs: {
                                      label: _vm.$t("GlobalSetObj.UpdateTime"),
                                      value: 2,
                                    },
                                  }),
                                  _c("el-option", {
                                    key: "3",
                                    attrs: {
                                      label: _vm.$t(
                                        "customerManagements.genterTiem"
                                      ),
                                      value: 3,
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c("el-date-picker", {
                            staticStyle: { width: "100%" },
                            attrs: {
                              type: "datetimerange",
                              "range-separator": "-",
                              "value-format": "yyyy-MM-dd HH:mm:ss",
                              "default-time": ["00:00:00", "23:59:59"],
                              "start-placeholder": _vm.$t(
                                "GlobalSetObj.startDate"
                              ),
                              "end-placeholder": _vm.$t("GlobalSetObj.endDate"),
                            },
                            model: {
                              value: _vm.dateTime,
                              callback: function ($$v) {
                                _vm.dateTime = $$v
                              },
                              expression: "dateTime",
                            },
                          }),
                        ],
                        2
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 5 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: { label: _vm.$t("collectionCenter.creator") },
                        },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "95%" },
                              attrs: {
                                placeholder: _vm.$t(
                                  "collectionCenter.pleaseChoose"
                                ),
                                size: "small",
                                clearable: "",
                                filterable: "",
                                remote: "",
                                "reserve-keyword": "",
                                "remote-method": _vm.getAllUser,
                              },
                              on: {
                                "visible-change": _vm.openCreateUserSelect,
                              },
                              model: {
                                value: _vm.queryForm.params.createUser,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.queryForm.params,
                                    "createUser",
                                    $$v
                                  )
                                },
                                expression: "queryForm.params.createUser",
                              },
                            },
                            _vm._l(_vm.allUserList, function (item, idx) {
                              return _c("el-option", {
                                key: idx,
                                attrs: { label: item.realName, value: item.id },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "div",
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary", size: "small" },
                      on: { click: _vm.queryTableData },
                    },
                    [_vm._v(" " + _vm._s(_vm.$t("newOrder.search")) + " ")]
                  ),
                  _c(
                    "el-button",
                    { attrs: { size: "small" }, on: { click: _vm.resetForm } },
                    [_vm._v(_vm._s(_vm.$t("collectionCenter.reset")))]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-card",
        [
          _c(
            "div",
            { staticStyle: { "margin-bottom": "10px" } },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary", size: "small" },
                  on: {
                    click: function ($event) {
                      return _vm.addConfiguration(1)
                    },
                  },
                },
                [_vm._v(" " + _vm._s(_vm.$t("GlobalSetObj.create")) + " ")]
              ),
            ],
            1
          ),
          _c(
            "el-table",
            {
              attrs: {
                data: _vm.tableData,
                border: "",
                "header-cell-style": {
                  background: "#e1e1e1",
                  color: "#000",
                  "font-size": "15px",
                },
              },
            },
            [
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("GlobalSetObj.serial"),
                  align: "center",
                  type: "index",
                  width: "80",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("mdfeTranslate.InsuranceCompany"),
                  "show-overflow-tooltip": "",
                  prop: "name",
                  "min-width": "180",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "CNPJ",
                  prop: "cnpj",
                  "min-width": "180",
                  "show-overflow-tooltip": "",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("mdfeTranslate.PolicyNumber"),
                  "show-overflow-tooltip": "",
                  prop: "policyNumberList",
                  align: "center",
                  "min-width": "180",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-button",
                          {
                            attrs: { type: "text", size: "small" },
                            on: {
                              click: function ($event) {
                                return _vm.showPolicyNumber(
                                  scope.row.policyNumberList
                                )
                              },
                            },
                          },
                          [
                            _c(
                              "span",
                              { staticStyle: { "font-size": "16px" } },
                              [
                                _vm._v(
                                  _vm._s(scope.row.policyNumberList.length)
                                ),
                              ]
                            ),
                          ]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("mdfeTranslate.ConfigurationName"),
                  "show-overflow-tooltip": "",
                  prop: "configName",
                  "min-width": "180",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("GlobalSetObj.EnableStatus"),
                  "min-width": "120",
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "div",
                          [
                            scope.row.state === 0
                              ? _c("el-tag", { attrs: { type: "danger" } }, [
                                  _vm._v(
                                    _vm._s(_vm.$t("GlobalSetObj.disable"))
                                  ),
                                ])
                              : _vm._e(),
                            scope.row.state === 1
                              ? _c("el-tag", { attrs: { type: "success" } }, [
                                  _vm._v(
                                    _vm._s(_vm.$t("collectionCenter.enable"))
                                  ),
                                ])
                              : _vm._e(),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("customerManagements.genterTiem"),
                  prop: "effectiveTime",
                  "min-width": "180",
                  align: "center",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("basicData.EffectiveStatus"),
                  "min-width": "180",
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "div",
                          [
                            scope.row.expirationState === 3
                              ? _c("el-tag", { attrs: { type: "danger" } }, [
                                  _vm._v(_vm._s(_vm.$t("basicData.Expired"))),
                                ])
                              : _vm._e(),
                            scope.row.expirationState === 2
                              ? _c("el-tag", { attrs: { type: "waring" } }, [
                                  _vm._v(
                                    _vm._s(_vm.$t("mdfeTranslate.Pending"))
                                  ),
                                ])
                              : _vm._e(),
                            scope.row.expirationState === 1
                              ? _c("el-tag", { attrs: { type: "success" } }, [
                                  _vm._v(
                                    _vm._s(_vm.$t("mdfeTranslate.InEffect"))
                                  ),
                                ])
                              : _vm._e(),
                            scope.row.expirationState === 4
                              ? _c("el-tag", { attrs: { type: "info" } }, [
                                  _vm._v(
                                    _vm._s(_vm.$t("mdfeTranslate.NotEffective"))
                                  ),
                                ])
                              : _vm._e(),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("collectionCenter.Note"),
                  "show-overflow-tooltip": "",
                  prop: "remark",
                  "min-width": "200",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("mdfeTranslate.ConfigurationID"),
                  prop: "id",
                  "min-width": "100",
                  align: "center",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("collectionCenter.creator"),
                  prop: "createUserStr",
                  "min-width": "160",
                  align: "center",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("collectionCenter.CreationTime"),
                  prop: "createTime",
                  "min-width": "180",
                  align: "center",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("basicData.LastModifier"),
                  prop: "updateUserStr",
                  "min-width": "160",
                  align: "center",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("basicData.LastModified"),
                  prop: "updateTime",
                  "min-width": "180",
                  align: "center",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("collectionCenter.operation"),
                  align: "center",
                  fixed: "right",
                  width: "180",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        scope.row.state === 0
                          ? _c(
                              "el-button",
                              {
                                attrs: { type: "text", size: "small" },
                                on: {
                                  click: function ($event) {
                                    return _vm.editStatus(scope.row)
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(_vm.$t("collectionCenter.enable")) +
                                    " "
                                ),
                              ]
                            )
                          : _vm._e(),
                        scope.row.state === 1
                          ? _c(
                              "el-button",
                              {
                                attrs: { type: "text", size: "small" },
                                on: {
                                  click: function ($event) {
                                    return _vm.editStatus(scope.row)
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(_vm.$t("GlobalSetObj.disable")) +
                                    " "
                                ),
                              ]
                            )
                          : _vm._e(),
                        _c(
                          "el-button",
                          {
                            attrs: { type: "text", size: "small" },
                            on: {
                              click: function ($event) {
                                return _vm.addConfiguration(2, scope.row)
                              },
                            },
                          },
                          [
                            _vm._v(
                              " " + _vm._s(_vm.$t("GlobalSetObj.edit")) + " "
                            ),
                          ]
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "right" },
            [
              _c("el-pagination", {
                staticStyle: { margin: "10px 0" },
                attrs: {
                  layout: "total, sizes, prev, pager, next, jumper",
                  "current-page": _vm.queryForm.pageNumber,
                  "page-sizes": [10, 20, 50, 100, 500],
                  "page-size": _vm.queryForm.pageSize,
                  total: _vm.total,
                  background: "",
                },
                on: {
                  "update:currentPage": function ($event) {
                    return _vm.$set(_vm.queryForm, "pageNumber", $event)
                  },
                  "update:current-page": function ($event) {
                    return _vm.$set(_vm.queryForm, "pageNumber", $event)
                  },
                  "update:pageSize": function ($event) {
                    return _vm.$set(_vm.queryForm, "pageSize", $event)
                  },
                  "update:page-size": function ($event) {
                    return _vm.$set(_vm.queryForm, "pageSize", $event)
                  },
                  "current-change": _vm.currentChange,
                  "size-change": _vm.sizeChange,
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-drawer",
        {
          staticClass: "drawerClass",
          attrs: {
            "close-on-click-modal": true,
            "destroy-on-close": true,
            title:
              _vm.editType === 1
                ? _vm.$t("GlobalSetObj.create")
                : _vm.$t("GlobalSetObj.edit"),
            visible: _vm.editConfigurationVisible,
            direction: "ltr",
            size: "80%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.editConfigurationVisible = $event
            },
          },
        },
        [
          _c("add-edit", {
            key: _vm.editConfigurationKey,
            attrs: { "row-data": _vm.rowData, "edit-type": _vm.editType },
            on: { closeWindow: _vm.closeWindow },
          }),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.$t("mdfeTranslate.PolicyNumber"),
            visible: _vm.policyNumberVisible,
            width: "600px",
            "close-on-press-escape": false,
            "close-on-click-modal": false,
            top: "5%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.policyNumberVisible = $event
            },
          },
        },
        [
          _c(
            "el-table",
            {
              attrs: {
                data: _vm.policyNumberData,
                border: "",
                "header-cell-style": {
                  background: "#e1e1e1",
                  color: "#000",
                  "font-size": "15px",
                },
              },
            },
            [
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("GlobalSetObj.serial"),
                  align: "center",
                  type: "index",
                  width: "80",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("mdfeTranslate.PolicyType"),
                  prop: "type",
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        scope.row.type === 1
                          ? _c("span", [
                              _vm._v(_vm._s(_vm.$t("mdfeTranslate.Accident"))),
                            ])
                          : _vm._e(),
                        scope.row.type === 2
                          ? _c("span", [
                              _vm._v(
                                _vm._s(_vm.$t("mdfeTranslate.TheftOfGoods"))
                              ),
                            ])
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("mdfeTranslate.PolicyNumber"),
                  prop: "number",
                  align: "center",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }